import CampagneController from './campagne.controller';

export default {
    template: require('./campagne.html'),
    controller: CampagneController
};
